/**
 * @功能名称: 关闭当前 webview
 * @文件名称: closeCurrentpage xyJSBridge之前的版本用app/operation/closeCurrentPage
 * @param: data={count:1 } // count | Number ，向前关闭count个webview，5月24日更新端上修改为关闭当前webview 去掉count参数
 * @Date: 2018/12/25 下午4:23.
 * @Author: liux
 * @Copyright（C）: 2014-2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */

import xyJsBridge from './xyJsBridge'
function closeCurrentPage(count=1) {
  var data = {count: count};
  return xyJsBridge('jsbridge://www.xiaoying.com/app/closeCurrentPage',data)
}

export default closeCurrentPage